import { Component, OnInit, HostListener, ViewChild, OnDestroy } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { TitleCasePipe } from "@angular/common";
import { LazyLoadEvent } from "primeng/api";
import { UserService } from "src/app/services/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { Table } from 'primeng/table';
import { Dropdown } from "primeng/dropdown";
import { SubscribeService } from "src/app/frontend/service/subscribeService.service";
import * as CryptoJS from "crypto-js";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import * as moment from "moment";
import { saveAs } from "file-saver/src/FileSaver";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: "app-addresslog",
  templateUrl: "./userKycList.component.html",
  styleUrls: ["./userKycList.component.scss"],
  providers: [MessageService, ConfirmationService, TitleCasePipe],
})

export class AdminUserKycListComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  public userlist: any = [];
  public loading: boolean;
  public totalRecords = 0;
  errorMessage: string;
  private lastTableLazyLoadEvent: LazyLoadEvent;
  username;
  userId;
  downloadwalletlist: any;
  noData: boolean;
  public profileDetails;
  presentKyaData: boolean;
  item: any;
  displayBasic: boolean | undefined;
  public showHighlightImg = "";
  paginationOption;
  private key = CryptoJS.enc.Utf8.parse(environment.EncryptKey);
  private iv = CryptoJS.enc.Utf8.parse(environment.EncryptIV);
  responsiveOptions: any[] = [
    {
      breakpoint: '1500px',
      numVisible: 5
    },
    {
      breakpoint: '1024px',
      numVisible: 3
    },
    {
      breakpoint: '768px',
      numVisible: 2
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  downloadFlg: boolean;
  statuses: any[];
  searchBy: any[];
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
  statusfalse: string;
  rejectKyc: boolean;
  rejectUpdateForm: FormGroup;
  submitted: boolean;
  UserKycData: any;
  viewReason: any;
  rejectKycReasonView: boolean = false;
  kycCompleteVerified: boolean=false;

  constructor(
    private userService: UserService,
    private activeroute: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private titlecasePipe: TitleCasePipe,
    private messageService: MessageService,
    private router: Router,
    private subscribeservice: SubscribeService,
    private formBuilder: FormBuilder,

  ) { }

  ngOnInit() {
    this.paginationOption = environment.pagination;

    this.userId = this.activeroute.snapshot.params.id;
    this.statuses = [
      { label: 'Approved', value: "Active" },
      { label: 'Pending', value: "Pending" }

    ];
    // this.loadUserKyc(this.lastTableLazyLoadEvent)
    this.rejectUpdateForm = this.formBuilder.group(
      {
        comment: ["", { validators: [Validators.required], updateOn: "blur", },]
      });
  }
  get f() {
    return this.rejectUpdateForm.controls;
  }
  changeStatus(user) {
        this.confirmationService.confirm({
        message: 'Do you confirm your decision to approve and activate the KYC for ' + (this.titlecasePipe.transform(user.userdetail[0].fullName)) + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
    var userData = {
      status:true
    }

    this.userService.updateUserKyc(user.Id, userData).pipe(takeUntil(this.destroy$)).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {

        this.messageService.add({
          key: "toastmsg",
          severity: "success",
          summary: "Successful",
          detail: "User Status Updated",
          life: 3000,
        });
        setTimeout(() => {
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate([this.router.url]);
      }, 3000);
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
    },
    reject: () => { }
    });
  }
  setDownloadFlag() {
    this.downloadFlg = false;
  }
  clear() {
    // this.startDate = null;
    // this.endDate = null;
    // this.searchby = '';
    this.dt.filter('', 'userName', 'contains');
    this.dt.filter('', 'pancardNumber', 'contains');
    this.dt.filter('', 'gstNumber', 'contains');
    this.dt.filter('', 'adharCardNumber', 'contains');
    // this.dt.filter('', 'statename', 'contains');
    // this.dt.filter('', 'cityname', 'contains');
    // this.dt.filter('', 'zipcode', 'contains');
    // this.dt.filter('', 'gender', 'contains');
    // this.dt.filter('', 'dob', 'dateIs');
    // this.dt.filter('', 'weddingDate', 'dateIs');
    // this.dt.filter('', 'created_at', 'dateIs');
    // this.dt.filter('', 'createdby', 'contains');
    // this.dt.filter('', 'updated_at', 'dateIs');
    // this.dt.filter('', 'updatedby', 'contains');
    // this.dt.filter('', 'mobile', 'contains');

    // this.calvalue = null;
    // this.ucalvalue = null;
    // this.dcalvalue = null;
    // this.wdcalvalue = null;
    this.pDropDownId.clear(null);
    if (this.pDropDownId) {
      this.pDropDownId.value = '';
    }
  }
  loadUserKyc(event: LazyLoadEvent) {
    var query = "?filterDisable=false&filterByRollName=player&filterByPrimary=true";
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }
    this.subscribeservice._pendingReq.pipe(takeUntil(this.destroy$)).pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res && event.filters["status"] == undefined) {
        this.statusfalse = res
        query += this.statusfalse
      }
    });
    //   if (this.downloadFlg == false) {
    //     if (params != undefined && params != "") {
    //       query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
    //     } else {
    query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
    //     }
    //   } else {
    // if (params != undefined && params != "") {
    //   query += params;
    // }
    //   }
    if (event.filters != undefined && event.filters["status"] != undefined) {
   
      if(event.filters["status"].value=="Pending"){
      query += "&filterByPending=true";
      }
      if(event.filters["status"].value=="Active"){
        query += "&filterByApproved=true";
        }

    }
    if (event.filters != undefined && event.filters["userName"] != undefined) {
      query += "&filterByfullName=" + event.filters["userName"].value;
    }
    if (event.filters != undefined && event.filters["pancardNumber"] != undefined) {
      query += "&filterByPancard=" + event.filters["pancardNumber"].value;
    }
    if (event.filters != undefined && event.filters["adharCardNumber"] != undefined) {
      query += "&filterByAadharCard=" + event.filters["adharCardNumber"].value;
    }
    //adharCardNumber
    if (event.filters != undefined && event.filters["gstNumber"] != undefined) {
      query += "&filterByGSTnumber=" + event.filters["gstNumber"].value;
    }
    this.userService.getUserKycDetailsList(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {
        this.loading = false;
        this.userService.getUser(this.userId).pipe(takeUntil(this.destroy$)).subscribe((detail) => {
          this.username = detail["fullName"];
        });
        this.totalRecords = data.totalCount;
        this.userlist = data.items
        if(data.items.length>0){
           this.userlist.forEach(kycEle=>{
            if(kycEle.bankData.length>0){
              kycEle.iskycCompleteVerified=kycEle.bankData[0].isBankVerified
            }
           })
        }
        // this.userlist.forEach(ele => {
        //   if (ele.panCardNumber != null) {
        //     ele.panCardNumber = CryptoJS.AES.decrypt(ele.panCardNumber, this.key, {
        //       keySize: 128 / 8,
        //       iv: this.iv, mode: CryptoJS.mode.CBC,
        //       padding: CryptoJS.pad.Pkcs7
        //     }).toString(CryptoJS.enc.Utf8)
        //   }
        //   if (ele.gstNumber != null) {
        //     ele.gstNumber = CryptoJS.AES.decrypt(ele.gstNumber, this.key, {
        //       keySize: 128 / 8,
        //       iv: this.iv, mode: CryptoJS.mode.CBC,
        //       padding: CryptoJS.pad.Pkcs7
        //     }).toString(CryptoJS.enc.Utf8)
        //   }
        //   if (ele.adharCardNumber != null) {
        //     ele.adharCardNumber = CryptoJS.AES.decrypt(ele.adharCardNumber, this.key, {
        //       keySize: 128 / 8,
        //       iv: this.iv, mode: CryptoJS.mode.CBC,
        //       padding: CryptoJS.pad.Pkcs7
        //     }).toString(CryptoJS.enc.Utf8)
        //   }
        //   ele.bankName = CryptoJS.AES.decrypt(ele.bankName, this.key, {
        //     keySize: 128 / 8,
        //     iv: this.iv, mode: CryptoJS.mode.CBC,
        //     padding: CryptoJS.pad.Pkcs7
        //   }).toString(CryptoJS.enc.Utf8)
        //   ele.accountNumber = CryptoJS.AES.decrypt(ele.accountNumber, this.key, {
        //     keySize: 128 / 8,
        //     iv: this.iv, mode: CryptoJS.mode.CBC,
        //     padding: CryptoJS.pad.Pkcs7
        //   }).toString(CryptoJS.enc.Utf8)
        //   ele.ifsc = CryptoJS.AES.decrypt(ele.ifsc, this.key, {
        //     keySize: 128 / 8,
        //     iv: this.iv, mode: CryptoJS.mode.CBC,
        //     padding: CryptoJS.pad.Pkcs7
        //   }).toString(CryptoJS.enc.Utf8)
        // })

        if (JSON.stringify(data) === '{}') {

          this.noData = false;
        } else {

          this.noData = true;
        }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  addKyc(id) {
    this.router.navigate(['/manage/user/kyc/add-kyc/' + id]);
  }

  public openHightlightImage(userlist) {
    this.displayBasic = true
    this.showHighlightImg = userlist.pancardPic;
  }

  @HostListener('window:keyup.esc', ['$event']) w(e: KeyboardEvent) {
    this.displayBasic = false;
  }
  // encryptData() {
  //   this.userlist.forEach(ele => {
  //     let updateData = {}

  //     updateData["bankName"] = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(ele["bankName"]), this.key, {
  //       keySize: 128 / 8,
  //       iv: this.iv,
  //       mode: CryptoJS.mode.CBC,
  //       padding: CryptoJS.pad.Pkcs7
  //     }).toString();
  //     updateData["accountNumber"] = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(ele["accountNumber"]), this.key, {
  //       keySize: 128 / 8,
  //       iv: this.iv,
  //       mode: CryptoJS.mode.CBC,
  //       padding: CryptoJS.pad.Pkcs7
  //     }).toString();
  //     updateData["ifsc"] = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(ele["ifsc"]), this.key, {
  //       keySize: 128 / 8,
  //       iv: this.iv,
  //       mode: CryptoJS.mode.CBC,
  //       padding: CryptoJS.pad.Pkcs7
  //     }).toString();
  //     if (ele["panCardNumber"] != undefined && ele["panCardNumber"] != "") {
  //       updateData["panCardNumber"] = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(ele["panCardNumber"]), this.key, {
  //         keySize: 128 / 8,
  //         iv: this.iv,
  //         mode: CryptoJS.mode.CBC,
  //         padding: CryptoJS.pad.Pkcs7
  //       }).toString();
  //     }
  //     if (ele["adharCardNumber"] != undefined && ele["adharCardNumber"] != "") {

  //       updateData["adharCardNumber"] = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(ele["adharCardNumber"]), this.key, {
  //         keySize: 128 / 8,
  //         iv: this.iv,
  //         mode: CryptoJS.mode.CBC,
  //         padding: CryptoJS.pad.Pkcs7
  //       }).toString();
  //     }
  //     if (ele["gstNumber"] != undefined && ele["gstNumber"] != "") {

  //       updateData["gstNumber"] = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(ele["gstNumber"]), this.key, {
  //         keySize: 128 / 8,
  //         iv: this.iv,
  //         mode: CryptoJS.mode.CBC,
  //         padding: CryptoJS.pad.Pkcs7
  //       }).toString();
  //     }
  //     // return;
  //     this.userService.addUserBankDetails(ele.Id, updateData).subscribe(
  //       (data) => {
  //         console.log(data)
  //         setTimeout(() => {
  //           let currentUrl = this.router.url;
  //           this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  //           this.router.onSameUrlNavigation = 'reload';
  //           this.router.navigate([currentUrl]);
  //         }, 2000)

  //       },
  //       (err) => {
  //         this.messageService.add({
  //           key: "toastmsg",
  //           severity: "error",
  //           summary: "Error",
  //           detail: err.error.message,
  //           life: 6000,
  //         });
  //       }
  //     );


  //   })
  // }
  showrejectmodal(data) {
    this.rejectKyc = true;
    this.UserKycData=data
  }
  changeStatusToReject() {
    this.submitted = true;
    if (this.rejectUpdateForm.invalid) {
        return;
    }
   
    var userData = {
      isRejected:true,
      status:false,
      rejectedReason:this.rejectUpdateForm.value.comment
    }
    // return;

    this.userService.updateUserKyc(this.UserKycData.Id, userData).pipe(takeUntil(this.destroy$)).subscribe(
      (data) => {

        this.messageService.add({
          key: "toastmsg",
          severity: "success",
          summary: "Successful",
          detail: "User Status Updated",
          life: 3000,
        });
        setTimeout(() => {
         
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate([this.router.url]);
        }, 2000);
      },
    )

}
viewRejectReasonModal(data){
  this.rejectKycReasonView=true
this.viewReason=data.rejectedReason
}

 exportExcel() {
    this.downloadFlg = true;
    this.loadUserKyc(this.lastTableLazyLoadEvent);
    var propertiesRemove = [
      "id",
      "created_at",
      "createdby",
      "updatedby",
      "disable",
      "updated_at",
      "status",
      "created_by",
      "Modification_Date",
    ];
    this.downloadwalletlist = this.userlist;
    this.downloadwalletlist.forEach(function (item) {
      if (item.updated_at != "") {
        item["Modification_Date"] = moment(item.updated_at).format(
          "DD/MM/YYYY"
        );
      }
      propertiesRemove.forEach(function (prop) {
        delete item[prop];
      });
    });
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(this.downloadwalletlist);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "Product");
    });
  }

    saveAsExcelFile(buffer: any, fileName: string): void {
      import("file-saver").then((FileSaver) => {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data: Blob = new Blob([buffer], {
          type: EXCEL_TYPE,
        });
        let filename;
        filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
        saveAs(data, filename);
      });
    }

ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
